import type { ReactElement } from 'react'
import { useRouter } from 'next/router'
import { appRoutes } from 'constants/appRoutes'
import classNames from 'classnames'

type Props = {
  isTransparent?:  boolean
}

const Footer = ({ isTransparent = false }: Props): ReactElement => {
  const { pathname } = useRouter()
  const isHelpCentre = pathname === '/help-centre';

  const footerClassName = classNames(
    isTransparent
      ? ' bg-transparent border border-gray-300'
      : ' bg-white border border-gray-200',
    'w-100 h-24 flex justify-center items-center border-b-0 border-r-0 border-l-0'
  );

  const copyrightClassName = classNames(
    isTransparent
      ? 'text-white'
      : 'text-black',
      'flex justify-center items-center grow'
  )

  return (
    <footer className={footerClassName}>
      <div className="text-center">
        <a
          href={appRoutes.HOME}
          className={copyrightClassName}
          target="_blank"
          rel="noopener noreferrer"
        >
          Copyright &#169;2022. All rights reserved.
        </a>
      </div>
    </footer>
  )
}

export default Footer;